var render = function render(){var _vm=this,_c=_vm._self._c;return _c('global-footer',{staticClass:"footer custom-render",scopedSlots:_vm._u([{key:"links",fn:function(){return undefined},proxy:true},{key:"copyright",fn:function(){return [_c('div',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Copyright 2020.HEFEI WATER All Rights Reserved. 版权所有：巢湖水业集团有限公司")])])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }